export default __webpack_public_path__ + "static/media/Autokritigallery_29.ed86eca7.JPG";